import { applyMiddleware, createStore, Store } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { History, createBrowserHistory } from 'history';
import { IAppState, IAppAction } from './app.types';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createAppReducer } from './app.reducer';
import { appSagaWatcher } from './app.saga-watchers';
import { routerMiddleware } from 'connected-react-router';
import { addFlashMessage } from '../utils/flashMessages.utils';
import * as Sentry from '@sentry/react';

let history: History | null = null;

export const getHistory = (): History => {
  if (!history) {
    history = createBrowserHistory();
  }

  return history;
};

const setUpStore = () => {
  const sagasMiddleware = createSagaMiddleware({
    onError: async (error, errorInfo) => {
      console.error(`Error in Saga middleware.`, error);
      Sentry.captureException(error, {
        extra: { sagaStack: errorInfo?.sagaStack },
      });
      addFlashMessage({
        type: 'error',
        message: 'Server error: please try again later',
        reloadOnCountdown: true,
      });
    },
  });

  const composeEnhancers = composeWithDevTools({
    maxAge: 50, // this is the default. In some cases it's helpful to increase this value to read more dispatched action from devtools
    // Specify here name, actionsBlacklist, actionsCreators and other options
  });

  const store = createStore<IAppState, IAppAction, {}, {}>(
    createAppReducer(getHistory()),
    composeEnhancers(applyMiddleware(routerMiddleware(getHistory()), sagasMiddleware)),
  );

  // eslint-disable-next-line @typescript-eslint/ban-types
  // const store = createStore<IAppState, IAppAction, {}, {}>(
  //   createAppReducer(getHistory()),
  //   composeWithDevTools(applyMiddleware(routerMiddleware(getHistory()), sagasMiddleware)),
  // );

  sagasMiddleware.run(appSagaWatcher);

  return store;
};

// singleton simulation
let store: Store<IAppState, IAppAction> | null = null;

export const configureStore = (): Store<IAppState, IAppAction> => {
  if (!store) {
    store = setUpStore();
  }

  return store;
};
